import React from 'react'
import { CountryFlag } from './Flag'
import { BioLink, CardCon, Footer, PlayerNameRow, StatsRow } from './styles'
import { logEvent } from '../../Utils'
import { Favorite } from '../Favorite'
import type { PlayerDataGQL } from '../../Api'
import { Injury } from '../../Pages/Player/components/Injury/Injury'
import { Img } from '../Image/Img'

type PersonStatsCardProps = {
  player: PlayerDataGQL
  playerPageUrl: string
}

export const PersonStatsCard: React.FC<
  React.PropsWithChildren<PersonStatsCardProps>
> = ({ player, playerPageUrl }) => {
  const log = (event: string) => {
    logEvent(event, {
      player: `${player.firstName} ${player.lastName}`,
      playerId: player.officialId,
      team: player.currentTeam.officialId,
    })
  }

  return (
    <CardCon cardType="roster">
      <div className="innerPad">
        <Img src={player.profileUrl} alt={player.slug} />
        <PlayerNameRow>
          <div className="number">
            <Favorite
              className="favMargin"
              name={player.slug}
              favType="favPlayers"
              player={player}
            />
            {player?.currentTeam?.jerseyNum !== null && (
              <div className="points">{player.currentTeam.jerseyNum}</div>
            )}
          </div>
          <div className="firstName">{player.firstName}</div>
          <div className="lastName">{player.lastName}</div>
          <Injury player={player} withPopper={true} />
          <CountryFlag countryCode={player.countryCode} className="flag" />
        </PlayerNameRow>

        <StatsRow>
          <div>
            <span>Position</span>
            <span>{player.currentTeam?.positionName}</span>
          </div>
          {player.handedness && (
            <div>
              <span>Hand</span>
              <span>{player.handedness}</span>
            </div>
          )}
          <div>
            <span>Height</span>
            <span>{player.height}</span>
          </div>
          {player.age && (
            <div>
              <span>Age</span>
              <span>{player.age}</span>
            </div>
          )}
          <div>
            <span>College</span>
            <span>{player.college}</span>
          </div>
        </StatsRow>
      </div>
      <BioLink
        to={playerPageUrl}
        onClick={() => {
          log('roster_bio_click')
        }}
      >
        <Footer>Full bio</Footer>
      </BioLink>
    </CardCon>
  )
}
